import * as React from "react";
const SvgArrowRightSmall24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 12,
        fill: "black",
        viewBox: "0 0 8 12"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2.207 11.707.793 10.293 5.086 6 .793 1.707 2.207.293 7.914 6l-5.707 5.707Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowRightSmall24Px;
